export const useIsFullscreenEnabled = () => {
    const isFullscreenEnabled = document?.fullscreenEnabled || document?.mozRequestFullScreen || document?.webkitFullscreenEnabled || document?.msFullscreenEnabled;

    return { isFullscreenEnabled };
};